import gql from 'graphql-tag'

export const UPDATE_PROGRESS = gql`
  mutation UpdateProgress($id: bigint!, $status: String) {
    update_performance_tasks(_set: {status: $status}, where: {id: {_eq: $id}}) {
      affected_rows
    }
  }
`
